import styled from 'styled-components';
import { tourDailogCommonStyles } from 'components/common/GuidedTour/GuidedTour.styled';
import { Button } from '@medly-components/core';

export const TourDialogBox = styled.div`
    ${tourDailogCommonStyles}

    ${Button.Style} {
        width: max-content;
        min-width: 10rem;
    }
`;

export const TourContent = styled.div``;

export const DialogBoxFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
`;
